/**
 * Tune format markers: ABC vs notation (📄) / audio (🎵) on browse and related-tune cards.
 */

import {
  collectTuneAudioIds,
  collectTuneNotationAssetIds,
  tuneNotationLegacyImageUrl,
} from './tunePageMedia';

function parseMeta(raw) {
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw || '{}');
  } catch (_) {
    return {};
  }
}

function truthyFlag(v) {
  return v === true || v === 1 || v === '1';
}

export function resolveTuneMediaFlags(item = {}) {
  if (
    item.type === 'abc-asset' ||
    item.pageType === 'abc-asset' ||
    item.itemType === 'tune-asset' ||
    item.assetId != null ||
    item.asset_id != null
  ) {
    return { isAbc: true, hasAudio: false, hasNotation: true };
  }

  if (truthyFlag(item.hasAudio) && truthyFlag(item.hasNotation)) {
    return { isAbc: false, hasAudio: true, hasNotation: true };
  }
  if (truthyFlag(item.has_audio) && truthyFlag(item.has_notation)) {
    return { isAbc: false, hasAudio: true, hasNotation: true };
  }

  const meta = parseMeta(item.metadata);
  const hasNotation =
    truthyFlag(item.hasNotation) ||
    truthyFlag(item.has_notation) ||
    collectTuneNotationAssetIds(meta).length > 0 ||
    !!tuneNotationLegacyImageUrl(meta) ||
    !!(meta.notation_asset_filenames && String(meta.notation_asset_filenames).trim());

  const hasAudio =
    truthyFlag(item.hasAudio) ||
    truthyFlag(item.has_audio) ||
    collectTuneAudioIds(meta).length > 0 ||
    !!(meta.mp3_asset_id) ||
    !!(meta.audio_asset_filenames && String(meta.audio_asset_filenames).trim());

  return { isAbc: false, hasAudio, hasNotation };
}

/** @returns {{ className: string, icons: string[], label: string, title: string } | null} */
export function getTuneFormatMarker(item) {
  const flags = resolveTuneMediaFlags(item);

  if (flags.isAbc) {
    return {
      className: 'tune-format-marker--abc',
      icons: ['🎼'],
      label: 'ABC',
      title: 'ABC notation tune — opens in the ABC player',
    };
  }

  const icons = [];
  if (flags.hasAudio) icons.push('🎵');
  if (flags.hasNotation) icons.push('📄');
  if (!icons.length) return null;

  let title = 'Tune page';
  if (flags.hasAudio && flags.hasNotation) title = 'Tune page with sheet notation and audio sample';
  else if (flags.hasAudio) title = 'Tune page with audio sample';
  else if (flags.hasNotation) title = 'Tune page with sheet notation';

  return {
    className: 'tune-format-marker--page',
    icons,
    label: icons.length > 1 ? '' : flags.hasAudio ? 'Audio' : 'Tune',
    title,
  };
}
